// extracted by mini-css-extract-plugin
export default {"restBg":"DHWfl_restBg","rest-text-con":"JSaJ3_rest-text-con","restTitle":"W452w_restTitle"};